export const TYPE = {
  MOBILE: 'mobile',
  FIXED: 'fixed'
}
